export const updateGroups = (groupsData) => {
    return {
      type: 'UPDATE_GROUPS',
      payload: groupsData
    };
  };